// English texts of the "core" area (language button, sign-in screens, profile email settings).
export default {
  "lang.label": "Language",
  "auth.tagline": "Project Planner",
  "auth.login.username": "Username or Email",
  "auth.login.password": "Password",
  "auth.login.submit": "Sign In",
  "auth.login.noAccount": "Don't have an account?",
  "auth.login.register": "Register",
  // The emails quote the part before "?" (backend email_text.rs): keep them in sync.
  "auth.login.forgot": "Forgot password? Recover account",
  "auth.login.offline": "← Continue working offline",
  "auth.signup.title": "Create Account",
  "auth.signup.username": "Username",
  "auth.signup.email": "Email (optional)",
  "auth.signup.password": "Password (min 8 chars)",
  "auth.signup.confirm": "Confirm Password",
  "auth.signup.submit": "Create Account",
  "auth.signup.haveAccount": "Already have an account?",
  "auth.signup.signIn": "Sign In",
  "auth.recover.title": "Recover Account",
  "auth.recover.intro": "Enter your username and 12-word recovery phrase to regain access to your account.",
  "auth.recover.username": "Username",
  "auth.recover.phrase": "Enter your 12-word recovery phrase...",
  "auth.recover.newPassword": "New Password (min 8 chars)",
  "auth.recover.confirm": "Confirm New Password",
  "auth.recover.submit": "Recover Account",
  "auth.recover.back": "Back to Sign In",
  "profile.invitations.label": "Invitation emails",
  "profile.invitations.toggle": "Email me when someone invites me to a map",
  "profile.invitations.hint": "Only to a verified address, at most once a day per person who invites you.",
  "profile.invitations.saved": "Saved.",
  "profile.invitations.failed": "Could not save. Please try again.",
  "profile.ignored.label": "Invitations ignored",
  "profile.ignored.hint": "People whose invitations you chose to always ignore.",
  "profile.ignored.none": "Nobody",
  "profile.ignored.stop": "Stop ignoring",
  "profile.ignored.failed": "Could not change this. Please try again.",
};
